"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _Icons = require("./Icons");
var _SurfaceSubtitle = _interopRequireDefault(require("./SurfaceSubtitle"));
var _SurfaceButton = _interopRequireDefault(require("./SurfaceButton"));
var _SurfaceAvatar = _interopRequireDefault(require("./SurfaceAvatar"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function Surface(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    icon = _ref.icon,
    backButton = _ref.backButton,
    children = _ref.children,
    buttons = _ref.buttons,
    ellipsisCallback = _ref.ellipsisCallback,
    ellipsisBuilder = _ref.ellipsisBuilder,
    footerActions = _ref.footerActions;
  var renderButtons = function renderButtons(variant) {
    var _a, _b;
    return (_b = (_a = buttons === null || buttons === void 0 ? void 0 : buttons.filter(function (button) {
      return button.available;
    })) === null || _a === void 0 ? void 0 : _a.filter(function (button) {
      return button.variant === variant;
    })) === null || _b === void 0 ? void 0 : _b.map(function (button, index) {
      return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        key: "button-".concat(index, "-").concat(variant),
        item: true,
        xs: "auto"
      }, /*#__PURE__*/_react["default"].createElement(_SurfaceButton["default"], Object.assign({}, button)));
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sx: {
      marginBottom: 2
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    spacing: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    md: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    spacing: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_SurfaceAvatar["default"], {
    icon: icon,
    backButton: backButton
  })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "h6"
  }, title)), subtitle && (/*#__PURE__*/_react["default"].createElement(_SurfaceSubtitle["default"], {
    subtitle: subtitle
  })))))), (buttons || !!ellipsisCallback || !!ellipsisBuilder) && (/*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sx: {
      display: {
        xs: 'flex',
        md: 'none'
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Divider, {
    sx: function sx(theme) {
      return {
        width: '100%',
        height: '1px',
        bgcolor: theme.palette.divider,
        mb: theme.spacing(0.5)
      };
    }
  })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    md: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "flex-end",
    alignContent: "center",
    alignItems: "center",
    spacing: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "flex-end",
    alignContent: "center",
    alignItems: "center",
    spacing: 2
  }, renderButtons('secondary'), renderButtons('primary'))), !!ellipsisCallback && (/*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    color: "inherit",
    size: "small",
    edge: "start",
    onClick: function onClick(event) {
      return ellipsisCallback(event.currentTarget);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icons.EllipsisIcon, null)))), !!ellipsisBuilder && (/*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, ellipsisBuilder())))))))), /*#__PURE__*/_react["default"].createElement(_material.Paper, {
    component: _material.Card,
    variant: "outlined"
  }, /*#__PURE__*/_react["default"].createElement(_material.CardContent, null, children), footerActions && /*#__PURE__*/_react["default"].createElement(_material.CardActions, null, footerActions)));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Surface);